import {
  ArrowDownIcon,
  BeakerIcon,
  BoltIcon,
  CheckIcon,
  ClockIcon,
  CubeIcon,
  ExclamationTriangleIcon,
  EyeSlashIcon,
  FireIcon,
  HandRaisedIcon,
  HeartIcon,
  LockClosedIcon,
  MinusIcon,
  MoonIcon,
  NoSymbolIcon,
  PlusIcon,
  ShieldCheckIcon,
  SparklesIcon,
  SpeakerXMarkIcon,
  SunIcon,
  TrashIcon,
  UserIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

export const ICONS = {
  eyeSlash: EyeSlashIcon,
  heart: HeartIcon,
  speakerXMark: SpeakerXMarkIcon,
  exclamationTriangle: ExclamationTriangleIcon,
  handRaised: HandRaisedIcon,
  noSymbol: NoSymbolIcon,
  bolt: BoltIcon,
  cube: CubeIcon,
  beaker: BeakerIcon,
  arrowDown: ArrowDownIcon,
  lockClosed: LockClosedIcon,
  sparkles: SparklesIcon,
  moon: MoonIcon,
  clock: ClockIcon,
  shieldCheck: ShieldCheckIcon,
  fire: FireIcon,
  sun: SunIcon,
  user: UserIcon,
  xMark: XMarkIcon,
  check: CheckIcon,
  plus: PlusIcon,
  minus: MinusIcon,
  trash: TrashIcon,
} as const;

export type IconName = keyof typeof ICONS;

export const ICON_NAMES = Object.keys(ICONS) as IconName[];
